/* Hide the duplicate sticky action only while the actual purchase row is visible. */
(() => {
  const bar = document.querySelector('.pd-mobile-bar');
  const actions = document.querySelector('#pd-form .pd-actions');
  if (!bar || !actions || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    bar.toggleAttribute('data-main-visible', entry.isIntersecting && entry.intersectionRatio >= .75);
  }, { threshold: [0, .75, 1], rootMargin: '-140px 0px 0px 0px' });
  observer.observe(actions);
})();